import React, { useState } from "react";
import logo from "../../assets/logo.svg";
import { Link, useLocation } from "react-router-dom";
import { HiMiniSignal } from "react-icons/hi2";
import { RiMenu3Line } from "react-icons/ri";
import clsx from "clsx";
import MobileNav from "./MobileNavbar";

const Navbar = () => {
  const [state, setState] = useState(false);

  return (
    <div>
      <div className="bg-secondary py-2 relative ">
        <nav className=" flex justify-between m-auto items-center max-w-7xl sticky top-0  max-md:px-5 max-sm:hidden">
          <Link to="/">
            <img className="max-w-16	max-sm:max-w-14" src={logo} alt="logo" />
          </Link>
          <div className=" cursor-pointer text-primary text-2xl sm:hidden ">
            <RiMenu3Line />
          </div>
          <ul className="flex gap-8 items-center text-sm font-medium max-sm:hidden ">
            <Child  name="Home" route="/" />
            <Child
              name={"Courses"}
              route={"/funnels"}
              onClick={() => setState(!state)}
            />
            <Child
              name={"Contact us"}
              route={"/ContactUs"}
              onClick={() => setState(!state)}
            />
          </ul>
        </nav>
        <MobileNav setState={setState} state={state} />
      </div>
    </div>
  );
};

export default Navbar;

let Child = ({ route, name, onClick }) => {
  let { pathname } = useLocation();
  let route_check = pathname.split(" ").pop();

  return (
    <>
      {name === "Courses" ? (
        <li>
          <Link
            className={clsx(
              route_check === route && "text-textColor",
              "flex items-center gap-2"
            )}
            to="/funnels">
            {name} <HiMiniSignal className="mt-[2px] text-[#FB2B3A] text-xl " />{" "}
          </Link>
        </li>
      ) : (
        <li
        
          className={clsx(route_check === route && "text-textColor")}>
          <Link to={route}>{name}</Link>
        </li>
      )}
    </>
  );
};
